import Path from "../../../../layouts/Path";
import { Button, Group, Stack, TextInput, Title } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../components/View/BackButton";
import { createTeam } from "../../../../api/UserAPI";
import PageTitle from "../../../../components/View/PageTitle";

const CreateTeamPage = () => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    createTeam(data?.name)
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.teams.row_highlight.created,
            color: "tertiary.8",
          });
        }, 300);
        navigate(`../?highlight=${response.data.team_id}`);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      <Group
        className="layout-block top"
        w={"100%"}
        gap={0}
        justify="space-between"
      >
        <PageTitle title={lang.teams.browser_tab_title} />
      </Group>
      <Stack
        className="layout-block"
        w={"40%"}
        mx={"auto"}
        gap={"xs"}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Title order={5}>{lang.teams.create.dialog.title}</Title>
        <TextInput
          name="name"
          label={lang.teams.create.dialog.name}
          placeholder={lang.teams.create.dialog.name}
          autoFocus
          required
        />

        <Group justify="flex-end">
          <BackButton />
          <Button type="submit" loading={loading}>
            {lang.teams.create.dialog.submit_button}
          </Button>
        </Group>
      </Stack>
    </>
  );
};

export default CreateTeamPage;
